import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainDisposeChargingPileException(id) {
  return maintainRequest({
    url: `/device/maintenanceMan/chargingPileException/disposeChargingPileException/${id}`,
    method: "post",
  });
}
